module.exports = __webpack_public_path__ + "img/B.00039f11.png";